import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import Select from "react-select";
import { formatSalesValue } from './../../../utils/formatUtils';

const WastageInputForm = ({
    editableClass,
    readonlyClass,
    selectedDate,
    setSelectedDate,
    loadingCC,
    errorCC,
    costCenterOptions,
    costCenter,
    setCostCenter,
    selectStyles,
    selectedOutlet,
    itemOptions,
    selectedItem,
    setSelectedItem,
    mainQuantity,
    setMainQuantity,
    subQuantity,
    setSubQuantity,
    showSubUnitInput,
    editingItemId,
    handleAddItem,
    handleCancelEdit,
    liveCost,
    liveRate,
    startDate
}) => {
    return (
        <>
            <div className="flex gap-12 mb-2.5">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Date
                    </label>
                    <input
                        type="date"
                        className={editableClass}
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        max={new Date().toLocaleDateString('en-CA')}
                        min={startDate && startDate}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Cost Center
                    </label>

                    <div className="text-sm w-[300px]">
                        {loadingCC ? (
                            <div className="flex items-center gap-2 p-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500">
                                <FaSpinner className="animate-spin text-blue-500 text-sm" />
                                <span className="text-sm">Loading cost centers...</span>
                            </div>
                        ) : errorCC ? (
                            <p className="col-span-3 text-red-500 text-sm">{errorCC}</p>
                        ) : (
                            <Select
                                options={costCenterOptions}
                                value={costCenter}
                                placeholder="Select cost center"
                                onChange={(option) => setCostCenter(option)}
                                styles={selectStyles}
                                isDisabled={!selectedOutlet}
                                isSearchable
                                isClearable
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-3 items-end gap-4 mb-2">
                <div className="col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Item
                    </label>

                    <Select
                        options={itemOptions}
                        value={
                            selectedItem
                                ? {
                                    value: selectedItem.id,
                                    label: selectedItem.name,
                                    data: selectedItem
                                }
                                : null
                        }
                        onChange={(selectedOption) => {
                            setSelectedItem(selectedOption?.data || null);
                            setMainQuantity("");
                            setSubQuantity("");
                        }}
                        isSearchable
                        placeholder="Search or select item..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                        styles={selectStyles}
                    />
                </div>

                <div className="col-span-2 grid grid-cols-3 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Primary Quantity {selectedItem?.uom ? `(${selectedItem?.uom})` : ""}
                        </label>

                        <input
                            type="number"
                            className={editableClass}
                            value={mainQuantity}
                            onChange={(e) => {
                                const value = e.target.value;

                                if (
                                    value === "" ||
                                    /^[0-9]*\.?[0-9]*$/.test(value)
                                ) {
                                    setMainQuantity(value);
                                }
                            }}
                            min="0"
                            step="any"
                            placeholder="Enter quantity"
                        />
                    </div>

                    {showSubUnitInput && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Secondary Quantity ({selectedItem?.secondaryUom || ""})
                            </label>


                            <input
                                type="number"
                                className={editableClass}
                                value={subQuantity}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    if (
                                        value === "" ||
                                        /^[0-9]*\.?[0-9]*$/.test(value)
                                    ) {
                                        setSubQuantity(value);
                                    }
                                }}
                                min="0"
                                step="any"
                                placeholder="Enter quantity"
                            />
                        </div>
                    )}

                    {selectedItem && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Estimated Cost (Rs. {formatSalesValue(liveRate)})
                            </label>
                            <div className={readonlyClass}>
                                {liveCost > 0 ? formatSalesValue(liveCost) : "-"}
                            </div>
                        </div>
                    )}
                </div>
            </div >

            <div className="flex gap-4 text-sm">
                <button
                    className={`py-1.5 px-3 rounded-md ${editingItemId
                        ? 'bg-yellow-600 hover:bg-yellow-700'
                        : 'bg-blue-600 hover:bg-blue-700'
                        } text-white`}
                    onClick={handleAddItem}
                >
                    {editingItemId ? "Update Item" : "Add Item"}
                </button>

                {editingItemId && (
                    <button
                        className="bg-gray-600 text-white py-1.5 px-3 rounded-md hover:bg-gray-700"
                        onClick={handleCancelEdit}
                    >
                        Cancel
                    </button>
                )}
            </div>
        </>
    );
};

export default WastageInputForm;